import { blue } from "@mui/material/colors";

const styles = {
  primaryContainer: {
    padding: 0,
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    marginBottom: "12px",
    gap: "10px",
  },
  tabContainer: {
    borderBottom: 1,
    borderColor: "divider",
    width: "100%",
  },
  tabPanel: {
    width: "100%",
    padding: "16px 0",
  },
  badge: {
    backgroundColor: blue[50],
    minWidth: '24px',
    height: '24px',
    color: blue[700],
    fontWeight: 'bold',
    borderRadius: '12px',
    padding: '0px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default styles;

